var _style, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgBrandingIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    width: "60px",
    height: "60px",
    viewBox: "0 0 60 60",
    style: {
      enableBackground: "new 0 0 60 60"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:#FFFFFF;}\n")), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M51.9,35.1c-0.6,0.4-1.4,0.7-2.5,1C46.9,36.7,29,40,25.2,40.7c-3.8,0.7-6.1-0.5-6.1-0.5l-7.5-4.4l-2.9-1.7 c0.3,0.5,0.8,0.9,1.3,1.2l8.1,6.2c0,0,1.9,1.2,5.1,1.1c3.3-0.1,23.9-0.7,23.9-0.7c2.8-0.1,4.9-2.4,4.9-5.1L51.9,35.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M44.1,13.3c0,0-20.8,4.1-23.4,4.6c-3.2,0.6-4.8,2.2-4.8,2.2l-6.6,7.8c-1,0.8-1.5,2.1-1.2,3.5 c0.3,1.3,1.2,2.4,2.4,2.8l9,4.8c0,0,2,0.9,5.2,0.2c3.2-0.6,23.5-4.6,23.5-4.6c2.7-0.5,4.5-3.1,4-5.9l-2.2-11.5 C49.4,14.5,46.8,12.7,44.1,13.3 M13.7,31.9c-0.8,0.5-1.9,0.3-2.4-0.5c-0.5-0.8-0.3-1.9,0.5-2.4c0.8-0.5,1.9-0.3,2.4,0.5 C14.7,30.3,14.5,31.4,13.7,31.9"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBrandingIcon);
export default __webpack_public_path__ + "static/media/branding_icon.ee1452f54c53612b5eaf5c6cf75f1c29.svg";
export { ForwardRef as ReactComponent };